import { useState } from "react";
import "./styles.scss";
import BarraDeNavegacao from "../../../componentes/BarraDeNavegacao";
import Relatorios from "..";
import RelatoriosAtendimentos from "../RelatorioAtendimentos/RelatorioAtendimentos";
import RelatorioProgramas from "../RelatorioProgramas";

const GerenciarRelatorios = () => {
  const [abaAtiva, setAbaAtiva] = useState("deInscricoes");

  return (
    <>
      <BarraDeNavegacao titulo="Relatórios" comBotaoADireita={false} />

      <div className="tabs-cadastro__menu1">
        <button
          className={abaAtiva === "deInscricoes" ? "ativo" : ""}
          onClick={() => setAbaAtiva("deInscricoes")}
        >
          De Inscrições
        </button>

        <button
          className={abaAtiva === "deAtendimentos" ? "ativo" : ""}
          onClick={() => setAbaAtiva("deAtendimentos")}
        >
          De atendimentos
        </button>

        <button
          className={abaAtiva === "deProgramas" ? "ativo" : ""}
          onClick={() => setAbaAtiva("deProgramas")}
        >
          De programas
        </button>
      </div>

      <div className="tabs-cadastro__conteudo1">
        {abaAtiva === "deInscricoes" && <Relatorios />}
        {abaAtiva === "deAtendimentos" && <RelatoriosAtendimentos />}
        {abaAtiva === "deProgramas" && <RelatorioProgramas />}
      </div>
    </>
  );
};

export default GerenciarRelatorios;
